import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { NavigationPod } from '../../NavigationPod/NavigationPod';
import type { CategorySectionProps } from './types';

/**
 * A section component that displays all casino categories in a responsive grid layout.
 * Mobile: 2 columns x 3 rows
 * Desktop <1024px: 3 columns x 2 rows
 * Desktop >1024px: 6 columns x 1 row
 *
 * @component
 * @param {string} [props.className] - Additional CSS classes to apply to the container
 * @returns {JSX.Element} A section displaying all categories in a grid format
 */

function CategorySection({ className, categories, namespace, isLiveCasino = false }: CategorySectionProps) {
  const t = useTranslations(namespace);
  const categoryRoutes = isLiveCasino ? ROUTES.LIVE_CASINO : ROUTES.CASINO;

  return (
    <section className={className} data-testid="category-section" data-track-title="Categories">
      <h2 className="mb-5 heading-5">{t('title')}</h2>
      <div className="grid grid-cols-2 grid-rows-3 gap-3 md:grid-cols-3 md:grid-rows-2 lg:grid-cols-6 lg:grid-rows-1">
        {categories.map((category, index: number) => (
          <NavigationPod
            key={category.id}
            icon={category.icon}
            renderLabel={(_, label) => <h3 className="paragraph-explanatory-strong">{label}</h3>}
            href={categoryRoutes.CATEGORY(category.slug)}
            label={t(`categories.${category.id}`)}
            iconDirection="stacked"
            data-track-position={index + 1}
            data-track-name={category.trackName}
          />
        ))}
      </div>
    </section>
  );
}

export { CategorySection };
